import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cx } from '../../../internal/cx.js';
/** Short status or metadata label. Never the only way to convey meaning: keep the text. */
export function Badge({ tone = 'neutral', variant = 'subtle', size = 'md', dot = false, className, children, ...rest }) {
    return (_jsxs("span", { ...rest, className: cx('mn-badge', className), "data-tone": tone, "data-variant": variant, "data-size": size, children: [dot ? _jsx("span", { className: "mn-badge__dot", "aria-hidden": true }) : null, children] }));
}
//# sourceMappingURL=badge.js.map